function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { render, hydrate } from "react-dom";
import { ApolloProvider } from "@apollo/client";
import { IntlProvider } from "react-intl";
import { Router } from "react-router-dom";
import canUseDOM from "dom-helpers/canUseDOM";
import { HelmetProvider } from "react-helmet-async";
import { loadableReady } from "@loadable/component";
import styled from "styled-components";
import Mousetrap from "mousetrap";
import NProgress from "nprogress";
import { addPersistedQueries, link, createClient } from "sprout-lib/dist/apollo";
import { Flex } from "sprout-ui-primitives";
// eslint-disable-next-line import/no-unresolved
import persistedQueries from "sprout-graphql/dist/client.json";
import "@sprout/assets/favicons";
import { getHistory } from "sprout-lib";
import App from "@sprout/containers/dist/App";
const client = createClient(link);
if (module.hot) module.hot.accept("sprout-graphql/dist/client.json", ()=>{
    addPersistedQueries(link, persistedQueries);
});
const bypassQueryMap = !((canUseDOM ? window.SPROUT_CONFIG.BYPASS_QUERY_MAP : process.env.BYPASS_QUERY_MAP) !== "1");
if (!bypassQueryMap) addPersistedQueries(link, persistedQueries);
NProgress.configure({
    showSpinner: false
});
if (canUseDOM) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { stopCallback  } = Mousetrap.prototype;
    const newStopCallback = (event, element, combo)=>{
        if ([
            "TEXTAREA",
            "INPUT"
        ].includes(element.tagName) || element.isContentEditable) {
            // allow these shortcuts to trigger despite being in inputs
            /**
       * https://sprout.io/todo/34234
       *
       * `mod+o` is technically only used on `PostDraftPage`, but to make
       * things easier, the logic is added here. Unless there is a way
       * to overwrite the settings in `actionRegistry`.
       */ if ([
                "mod+j",
                "mod+h",
                "mod+k",
                "mod+e",
                "mod+o"
            ].includes(combo)) return false;
        }
        if (element.tagName === "BUTTON" && [
            "enter",
            "space"
        ].includes(combo)) return true;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return stopCallback(event, element, combo);
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Mousetrap.prototype.stopCallback = newStopCallback;
}
const RootApp = ()=>/*#__PURE__*/ _jsx(HelmetProvider, {
        children: /*#__PURE__*/ _jsx(ApolloProvider, {
            client: client,
            children: /*#__PURE__*/ _jsx(IntlProvider, {
                locale: "en",
                children: /*#__PURE__*/ _jsx(Router, {
                    history: getHistory(),
                    children: /*#__PURE__*/ _jsx(App, {})
                })
            })
        })
    });
// eslint-disable-next-line @typescript-eslint/no-floating-promises
_asyncToGenerator(function*() {
    if (process !== false) throw new Error("@sprout/client should not be required directly from SSR");
    const MOUNT_NODE = document.getElementById("sprout");
    if (!MOUNT_NODE) throw new Error("Could not find the element to mount Sprout in");
    if (process.env.NODE_ENV === "development" && !bypassQueryMap && Object.keys(persistedQueries).length === 0) {
        const Disclaimer = styled(Flex)`
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    `;
        render(/*#__PURE__*/ _jsx(Disclaimer, {
            alignItems: "center",
            justifyContent: "center",
            children: "Persisted queries failed to load. Please edit one of the components and then try again."
        }), MOUNT_NODE);
        return;
    }
    try {
        if (!MOUNT_NODE.children.length) throw new Error("Server-side rendering error occurred.");
        yield loadableReady(()=>{
            hydrate(/*#__PURE__*/ _jsx(RootApp, {}), MOUNT_NODE);
        });
    } catch (e) {
        render(/*#__PURE__*/ _jsx(RootApp, {}), MOUNT_NODE);
    }
    if (window.Cypress) // Give it a moment to catch up, then signal Cypress we're ready.
    setTimeout(()=>{
        window.appReady = true;
    }, 50);
})();
if (window.SPROUT_CONFIG.INTERCOM_APP_ID) {
    /* eslint-disable */ const loadIntercom = require("@sprout/containers/dist/intercom").default;
    loadIntercom(window.SPROUT_CONFIG.INTERCOM_APP_ID);
/* eslint-enable */ }
if (window.SPROUT_CONFIG.RAVEN_DSN) // eslint-disable-next-line @typescript-eslint/no-floating-promises
import(/* webpackChunkName: "sentry" */ "./sentry");
